import { StudentForDiagnostic } from './../../../../Elearning-Models';
import { APIService } from './../../../../Services/API-Service/api-service';
import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { IAPIService } from 'src/app/Services/API-Service/IAPIService';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-skipped-students-dialog',
  templateUrl: './skipped-students-dialog.component.html',
  styleUrls: ['./skipped-students-dialog.component.scss']
})
export class SkippedStudentsDialogComponent implements OnInit {
  
  removeClicked = new EventEmitter<any>();
  title:string;
  diagnosticExamID: number;
  isLoading:boolean = false;
  students:StudentForDiagnostic[] = [];
  mappedStudents:number[] = [];
  method: number;

  constructor(
    private APIService: IAPIService,
    public dialogRef: MatDialogRef<SkippedStudentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
      this.title = data.title;
      this.diagnosticExamID= data.diagnosticExamID;
      this.method = data.method;

      if(this.method == 2){
        this.students = data.students;
      }
    }

  ngOnInit(): void {
    switch (this.method) {
      case 1: {
        this.getSkippedStudents();
        break;
      }
    }
  }

  getSkippedStudents = () => {
    this.isLoading = true;
    this.APIService.GetSkippedStudentsList(this.diagnosticExamID).subscribe((response: StudentForDiagnostic[]) => {
      this.students = response;
      this.isLoading = false;
    })
  }

  onStudentSelect = (id) => {
    if(this.mappedStudents.includes(id)){
      const index: number = this.mappedStudents.indexOf(id);
      if (index !== -1) {
        this.mappedStudents.splice(index, 1);
      }
    } else {
      this.mappedStudents.push(id);
    }
  }

  onCancel = () => {
    this.dialogRef.close();
  }

  onRemoveFromSkipped = () => {
    const skippedStudents:StudentForDiagnostic[]= [];
    this.mappedStudents.map(studentID => {
      this.students.map(student => {
        if(student.StudentID === studentID) {
          skippedStudents.push(student);
        }
      })
    })
    this.removeClicked.emit(skippedStudents);
    this.dialogRef.close();

  }

 }
